const SPRITES = [
  'bear_thanks',
  'custom_levels',
  'dustgirl_victory',
  'dustkid_victory',
  'dustman_victory',
  'dustworth_victory',
  'dustwraith_victory',
  'freeman',
  'leafsprite_victory',
  'maid_cleansed',
  'npc',
  'play_custom',
  'porcupine_idle',
  'raccoon1_thanks',
  'raccoon2_thanks',
  's_rank',
  'settings_icon',
  'skull',
  'slimebeast_thanks',
  'slimeboss_victory',
  'stoneboss_land',
  'trashbeast_thanks',
  'trashking_victory',
  'vdustgirl_victory',
  'vdustkid_victory',
  'vdustman_victory',
  'vdustworth_victory',
];

export { SPRITES as default };
